import { FC, useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import Breadcrumb from '../../Components/Breadcrumb';
import ApprovService from './service'; 

//Moment react
import Moment from 'react-moment';

import {
    Link, useNavigate
} from "react-router-dom";
import SalaryService from './service';
import { useTranslation } from 'react-i18next';

const SupervizeSalaryList: FC = () => {  
    let idToModInit: any = null;
    const [ salaries, setSalaries ] = useState( [] );
    const [ idToMod, setIdToMod ] = useState(idToModInit);
    const [ loading, setLoading ] = useState(false);
    const salaryService = new SalaryService();

    const navigate = useNavigate();
    const { t } = useTranslation();

    let editAgent = (id: Number): void => {
        setIdToMod(id);
        setLoading(true);
        navigate('/agent/edit/'+id.toString());
        setLoading(false);
    }

    const getSupervizeSalaries = () => {
        setLoading(true);
        salaryService.getSupervizeSalaries().then(async function (response: any) {
            console.log(response);
            setSalaries(response.data);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }

    useEffect( function() { 
        getSupervizeSalaries();
    }, []);

    const columns = [
        {
            name: t('Superviseur') ,
            selector: (row: any) => row.Superviser.prenomAgent + ' ' + row.Superviser.nomAgent,
        }, 
        {
            name: t('Agent'),
            selector: (row: any) => row.agent.prenomAgent + ' '+  row.agent.nomAgent,
        },
        {
            name: t('Boutique'),
            selector: (row: any) => row.boutique.libBoutique,
        },
        {
            name: t('Salaire'),
            selector: (row: any) => row.salaire.libelle,
        },
        {
            name: t("Montant"),
            selector: (row: any) => row.montant,
        },
        {
            name: t('Date payement'),
            selector: (row: any) => <Moment format="YYYY/MM/DD hh:mm:ss">
                                        {row.datePayement}
                                    </Moment>
        },
        {
            name: t('Date supervision'),
            selector: (row: any) => <Moment format="YYYY/MM/DD hh:mm:ss">
                                        {row.dateSupervision}
                                    </Moment>
        } 
    ];
    

    return (
            <> 
                <Breadcrumb />
 
                <div className="container-fluid">
    
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="btn-list">
                                    <button type="button" onClick={ event => getSupervizeSalaries() }
                                        className="btn waves-effect waves-light btn-danger">
                                            { t("Actualiser") }
                                        </button>
                                        {/* <Link type="button" to="/approvisionnement/create"
                                            className="btn waves-effect waves-light btn-primary">
                                                Ajouter un approvisonnement
                                        </Link> */}
                                    </div>
                                    
                                    <br />
                                    <br />
                                    {/* <h4 className="card-title">Zero Configuration</h4>
                                    <h6 className="card-subtitle">DataTables has most features enabled by default, so all you
                                        need to do to use it with your own tables is to call the construction
                                        function:<code> $().DataTable();</code>. You can refer full documentation from here
                                        <a href="https://datatables.net/">Datatables</a></h6> */}
                                    <div className="table-responsive">
                                        <DataTable
                                            responsive={true}
                                            className="table table-striped table-bordered"
                                            columns={columns}
                                            data={salaries}
                                            progressPending={loading}
                                            pagination
                                        />
                                        </div>
                                    </div>
                                </div> 
                        </div> 
                    </div>

                </div>   
            </>                   

    );
}

export default SupervizeSalaryList